<script setup lang="ts">
import { ElementalTypeEnum } from '~~/src/types/elemental'
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import ElementalIconPicker from '@/components/Elemental/ElemetalIconPicker/index.vue'

defineOptions({
  name: 'CreateTableButton',
})

const colors = getElementTypeColor(ElementalTypeEnum.Table)
const { createTable, isPending } = useCreateTable()

const handlerCreateTable = () => {
  createTable()
}
</script>

<template>
  <MenuItem
    class="gap-3"
    @select="handlerCreateTable()"
  >
    <template #icon-wrapper>
      <div :style="{ background: colors[1], color: colors[0] }" class="h-7 w-7 rounded-1 flex items-center justify-center">
        <ElementalIconPicker :type="ElementalTypeEnum.Table" />
      </div>
    </template>
    <span class="font-inter font-700 text-sm leading-[22.4px]">
      Table
    </span>
  </MenuItem>
  <Teleport v-if="isPending" to="body">
    <div class="absolute h-100[dvh] w-100[dvh] inset-0 z-999">
      <LoadingOverlay message="Creating table..." />
    </div>
  </Teleport>
</template>
